const japan = {
  hello: 'japan',
  chooseStatus: '選択済み',
  timeTitle: 'イベント修了カウントダウン',
  timeTitle1: 'アクティビティが終了しました',
  timeTitle2: 'アクティビティが開始されていません',
  days: '日',
  hour: '時',
  minute: '分',
  second: '秒',
  allNumsName: '総票数',
  playnumsName: '候補数',
  votenumsName: 'アクセス人数',
  voteStart: '投票開始',
  voteEnd: '投票終了',
  voteRule: '投票ルール',
  activeRule: '評価ルール',
  searchTip: '選手番号若しくは名前をご入力ください',
  searchBtn: '検索',
  vote: '投票',
  playerNo: '番',
  introduce: 'プロフィール',
  activeIntroduce: 'イベントの紹介',
  rank: 'ランキング',
  rankName: '順位',
  rankName2: 'ランキング',
  voteNums: '票数',
  voteUnit: '票',
  infoBtn: '詳細',
  loadding: 'ロード中···',
  noDesc: '概要はありません',
  lastNext: 'より近い上位との票数差',
  numbers: '票数',
  helpme: '応援する',
  report: '通報する',
  first: '第1位',
  now: '現在',
  change: '言語の切り替え',
  share1: '右上をクリックしてください',
  share2: '指定された友人に送信',
  share3: 'モーメンツに共有したり',
  rules: '各WeChatアカウントの1日の最大投票回数は5回となり、同じ選手に投票することはできません。',
  all: 'すべて',
}
export default japan